import positionsConfigJson from './positionsConfig.json'
import itemsConfigJson from './itemsConfig.json'
import { GlobalState } from './globalState'
import type { ItemsConfig, IPositionsConfig } from '../data/types'

const itemsConfig: ItemsConfig = itemsConfigJson
const positionsConfig: IPositionsConfig = positionsConfigJson

GlobalState.itemsConfig = itemsConfig
GlobalState.positionsConfig = positionsConfig
